import { AssetTabsTypes } from '../components/AssetTabs';
import { getAllProductsEnabled, productsConstants } from '../constants';

export type OperationType = 'buy' | 'sell';

export const generateInitialTabs = (isBatchTicket = false): AssetTabsTypes.AssetTabsProps[] => {
  const unleashProp = isBatchTicket ? 'unleashFlagBatchTicket' : 'unleashFlag';

  return getAllProductsEnabled([...productsConstants], unleashProp);
};
